(function () {
	if (window.__cusaAnalyticsMonitor) return;
	window.__cusaAnalyticsMonitor = true;

	const STORAGE_KEY = 'cusaAnalyticsMonitor';
	const FORCE_KEY = 'cusaAnalyticsMonitorForce';

	// Gate: hide in the Shopify theme customizer — it interferes with the editor UI.
	if (window.Shopify?.designMode) return;

	// Gate: dev is auto-enabled via window.__cusaAnalyticsMonitorDev (set by cusa-analytics.liquid).
	// Prod requires an explicit opt-in. Either environment can be force-disabled.
	const forceState = localStorage.getItem(FORCE_KEY);
	if (forceState === 'disabled') return;
	if (!window.__cusaAnalyticsMonitorDev && forceState !== 'enabled') return;

	// ─── Styles ──────────────────────────────────────────────────────────────

	const style = document.createElement('style');
	style.textContent = `
		#cusa-analytics-monitor {
			position: fixed;
			bottom: 1rem;
			right: 1rem;
			width: min(430px, calc(100dvw - 2rem));
			max-height: 480px;
			min-width: min(430px, calc(100dvw - 2rem));
			min-height: 180px;
			resize: both;
			background: #1e1e1e;
			color: #d4d4d4;
			font: 12px/1.5 monospace;
			border-radius: 8px;
			box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
			z-index: 99999;
			display: flex;
			flex-direction: column;
			overflow: hidden;
			box-sizing: border-box;
		}
		#cusa-analytics-monitor[data-cam-state="hidden"] { display: none; }
		#cusa-analytics-monitor[data-cam-state="collapsed"] { min-height: 0; height: auto !important; resize: none; }
		#cusa-analytics-monitor .cam-header {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 8px 10px;
			background: #2d2d2d;
			border-bottom: 1px solid #3a3a3a;
			flex-shrink: 0;
			cursor: grab;
			user-select: none;
		}
		#cusa-analytics-monitor .cam-header:active { cursor: grabbing; }
		#cusa-analytics-monitor .cam-title {
			font-weight: bold;
			color: #4ade80;
			white-space: nowrap;
		}
		#cusa-analytics-monitor .cam-count {
			background: #4ade80;
			color: #1e1e1e;
			border-radius: 10px;
			padding: 0 5px;
			font-size: 10px;
			font-weight: bold;
		}
		#cusa-analytics-monitor .cam-controls {
			display: flex;
			align-items: center;
			gap: 6px;
			flex: 1;
			min-width: 0;
			justify-content: flex-end;
		}
		#cusa-analytics-monitor .cam-filter {
			background: #3a3a3a;
			border: 1px solid #555;
			color: #d4d4d4;
			border-radius: 4px;
			padding: 3px 7px;
			font: inherit;
			flex: 1;
			min-width: 0;
			cursor: text;
		}
		#cusa-analytics-monitor .cam-filter::placeholder { color: #666; }
		#cusa-analytics-monitor .cam-filter::-webkit-search-cancel-button {
			-webkit-appearance: none;
			appearance: none;
			width: 8px;
			height: 8px;
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='M1 1l10 10M11 1L1 11' stroke='%23d4d4d4' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
			background-repeat: no-repeat;
			background-position: center;
			cursor: pointer;
		}
		#cusa-analytics-monitor .cam-filter:not(:placeholder-shown) {
			border-color: rgba(74, 222, 128, 0.35);
		}
		#cusa-analytics-monitor .cam-filter:focus {
			outline: none;
			border-color: #4ade80;
		}
		#cusa-analytics-monitor .cam-filter::selection {
			background: #4ade80;
			color: #1e1e1e;
		}
		#cusa-analytics-monitor .cam-btn {
			background: #3a3a3a;
			border: 1px solid #555;
			color: #d4d4d4;
			border-radius: 4px;
			padding: 3px 8px;
			cursor: pointer;
			font: inherit;
			line-height: 1;
			flex-shrink: 0;
		}
		#cusa-analytics-monitor .cam-btn:hover { background: rgba(74, 222, 128, 0.12); border-color: #4ade80; color: #4ade80; }
		#cusa-analytics-monitor .cam-body {
			overflow-y: auto;
			flex: 1;
			min-height: 0;
			background: #1e1e1e;
			overscroll-behavior: contain;
		}
		#cusa-analytics-monitor .cam-empty {
			padding: 16px;
			color: #999;
			text-align: center;
		}
		#cusa-analytics-monitor .cam-list {
			list-style: none;
			margin: 0;
			padding: 0;
		}
		#cusa-analytics-monitor .cam-event {
			border-bottom: 1px solid #2a2a2a;
		}
		#cusa-analytics-monitor .cam-event details > summary {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 6px 10px;
			cursor: pointer;
			color: #58cffc;
			list-style: none;
			user-select: none;
		}
		#cusa-analytics-monitor .cam-event details > summary:hover { background: #272727; }
		#cusa-analytics-monitor .cam-event details[open] > summary { color: #4ade80; }
		#cusa-analytics-monitor .cam-event .cam-num {
			color: #a1a1aa;
			font-size: 10px;
			min-width: 3ch;
			text-align: right;
			flex-shrink: 0;
			user-select: none;
		}
		#cusa-analytics-monitor .cam-event .cam-time {
			color: #a1a1aa;
			font-size: 10px;
			margin-left: auto;
			white-space: nowrap;
		}
		#cusa-analytics-monitor .cam-event pre {
			margin: 0;
			padding: 8px 12px 10px 36px;
			color: #a1a1aa;
			white-space: pre-wrap;
			word-break: break-all;
			border-top: 1px solid #2a2a2a;
		}
		#cusa-analytics-monitor .cam-event pre .cam-json-key     { color: #58cffc; }
		#cusa-analytics-monitor .cam-event pre .cam-json-string  { color: #fabe74; }
		#cusa-analytics-monitor .cam-event pre .cam-json-number  { color: #86efac; }
		#cusa-analytics-monitor .cam-event pre .cam-json-boolean { color: #d545ff; }
		#cusa-analytics-monitor .cam-event pre .cam-json-null    { color: #94a3b8; }
		#cusa-analytics-monitor .cam-scroll-btn {
			position: sticky;
			bottom: 8px;
			display: block;
			margin: 6px auto;
			background: #2d2d2d;
			border: 1px solid #4ade80;
			color: #4ade80;
			border-radius: 4px;
			padding: 4px 12px;
			cursor: pointer;
			font: inherit;
			font-size: 11px;
			line-height: 1;
		}
		#cusa-analytics-monitor .cam-scroll-btn:hover { background: #3a3a3a; }
		#cusa-analytics-monitor .cam-scroll-btn[hidden] { display: none; }
		#cusa-analytics-monitor .cam-event .cam-copy-btn {
			opacity: 0;
			padding: 1px 5px;
			font-size: 11px;
			flex-shrink: 0;
			transition: opacity 0.15s;
			margin-left: 4px;
		}
		#cusa-analytics-monitor .cam-event details > summary:hover .cam-copy-btn,
		#cusa-analytics-monitor .cam-event .cam-copy-btn:focus { opacity: 1; }
		#cusa-analytics-pill {
			position: fixed;
			bottom: 1rem;
			right: 1rem;
			background: #2d2d2d;
			border: 1px solid #3a3a3a;
			border-radius: 6px;
			padding: 6px 10px;
			color: #4ade80;
			font: bold 11px/1 monospace;
			cursor: pointer;
			z-index: 99999;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
			display: flex;
			align-items: center;
			gap: 6px;
			opacity: 0.35;
			transition: opacity 0.2s ease;
		}
		#cusa-analytics-pill:hover,
		#cusa-analytics-pill:focus,
		#cusa-analytics-pill:active { opacity: 1; background: #3a3a3a; }
		#cusa-analytics-pill[hidden] { display: none; }
		#cusa-analytics-pill .cam-pill-count {
			background: #4ade80;
			color: #1e1e1e;
			border-radius: 10px;
			padding: 0 5px;
			font-size: 10px;
		}
	`;
	document.head.appendChild(style);

	// ─── Markup ───────────────────────────────────────────────────────────────

	const panel = document.createElement('div');
	panel.id = 'cusa-analytics-monitor';
	panel.innerHTML = `
		<div class="cam-header">
			<span class="cam-title">Analytics <span class="cam-count">0</span></span>
			<div class="cam-controls">
				<input class="cam-filter" type="search" placeholder="filter events…" autocomplete="off">
				<button class="cam-btn cam-reset-pos-btn" title="Reset position">⌂</button>
				<button class="cam-btn cam-reset-size-btn" title="Reset size">⊡</button>
				<button class="cam-btn cam-clear-btn">Clear</button>
				<button class="cam-btn cam-collapse-btn">−</button>
				<button class="cam-btn cam-close-btn">×</button>
			</div>
		</div>
		<div class="cam-body">
			<p class="cam-empty">No events yet.</p>
			<ul class="cam-list" hidden></ul>
		</div>
	`;
	document.body.appendChild(panel);

	const pill = document.createElement('button');
	pill.id = 'cusa-analytics-pill';
	pill.innerHTML = `Analytics <span class="cam-pill-count">0</span>`;
	document.body.appendChild(pill);

	const countEl = panel.querySelector('.cam-count');
	const pillCount = pill.querySelector('.cam-pill-count');
	const list = panel.querySelector('.cam-list');
	const emptyMsg = panel.querySelector('.cam-empty');
	const filterInput = panel.querySelector('.cam-filter');
	const clearBtn = panel.querySelector('.cam-clear-btn');
	const resetPosBtn = panel.querySelector('.cam-reset-pos-btn');
	const resetSizeBtn = panel.querySelector('.cam-reset-size-btn');
	const collapseBtn = panel.querySelector('.cam-collapse-btn');
	const closeBtn = panel.querySelector('.cam-close-btn');
	const camBody = panel.querySelector('.cam-body');
	const header = panel.querySelector('.cam-header');

	const MAX_EVENTS = 200;

	let count = 0;
	let autoScroll = true;

	// ─── Storage ──────────────────────────────────────────────────────────────

	function loadStorage() {
		try {
			const raw = localStorage.getItem(STORAGE_KEY);
			if (!raw) return { state: 'open', pos: null };
			// Migrate legacy plain-string format
			if (raw === 'open' || raw === 'collapsed' || raw === 'hidden') {
				return { state: raw, pos: null };
			}
			return JSON.parse(raw);
		} catch {
			return { state: 'open', pos: null };
		}
	}

	function saveStorage(patch) {
		const current = loadStorage();
		localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...current, ...patch }));
	}

	// ─── State ────────────────────────────────────────────────────────────────

	// States: 'open' | 'collapsed' | 'hidden'
	function setState(state) {
		saveStorage({ state });
		applyState(state);
	}

	function applyState(state) {
		panel.dataset.camState = state;
		camBody.hidden = state === 'collapsed';
		collapseBtn.textContent = state === 'collapsed' ? '▴' : '▾';
		pill.hidden = state !== 'hidden';
		if (state === 'open') applySize(loadStorage().size);
	}

	// ─── Position & Size ──────────────────────────────────────────────────────

	function applyPosition(pos) {
		if (!pos) return;
		// Clamp to viewport in case window was resized since last save
		const maxX = window.innerWidth - panel.offsetWidth;
		const maxY = window.innerHeight - panel.offsetHeight;
		const x = Math.max(0, Math.min(pos.x, maxX));
		const y = Math.max(0, Math.min(pos.y, maxY));
		panel.style.left = x + 'px';
		panel.style.top = y + 'px';
		panel.style.right = 'auto';
		panel.style.bottom = 'auto';
	}

	function applySize(size) {
		if (size) {
			// Clamp to viewport so a saved size never overflows after a resize.
			// Math.min naturally restores the full saved size when the viewport grows back.
			const maxW = window.innerWidth - 32;
			const maxH = window.innerHeight - 32;
			panel.style.maxHeight = 'none';
			panel.style.width = Math.min(size.w, maxW) + 'px';
			panel.style.height = Math.min(size.h, maxH) + 'px';
		} else {
			// Let CSS max-height: 480px govern; panel shrinks to content naturally
			panel.style.maxHeight = '';
			panel.style.width = '';
			panel.style.height = '';
		}
	}

	function resetPosition() {
		saveStorage({ pos: null });
		panel.style.left = '';
		panel.style.top = '';
		panel.style.right = '';
		panel.style.bottom = '';
	}

	function resetSize() {
		saveStorage({ size: null });
		applySize(null);
	}

	// ─── Drag ─────────────────────────────────────────────────────────────────

	let dragOffset = null;

	function getClient(e) {
		return e.touches ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
	}

	function onDragStart(e) {
		// Don't drag when interacting with buttons or the filter input
		if (e.target.closest('button, input')) return;
		e.preventDefault();

		const client = getClient(e);
		const rect = panel.getBoundingClientRect();
		dragOffset = { x: client.x - rect.left, y: client.y - rect.top };

		document.body.style.cursor = 'grabbing';
		document.addEventListener('mousemove', onDrag);
		document.addEventListener('mouseup', onDragEnd);
		document.addEventListener('touchmove', onDrag, { passive: false });
		document.addEventListener('touchend', onDragEnd);
	}

	function onDrag(e) {
		if (!dragOffset) return;
		if (e.cancelable) e.preventDefault();

		const client = getClient(e);
		const x = Math.max(0, Math.min(client.x - dragOffset.x, window.innerWidth - panel.offsetWidth));
		const y = Math.max(0, Math.min(client.y - dragOffset.y, window.innerHeight - panel.offsetHeight));

		panel.style.left = x + 'px';
		panel.style.top = y + 'px';
		panel.style.right = 'auto';
		panel.style.bottom = 'auto';
	}

	function onDragEnd() {
		if (!dragOffset) return;
		dragOffset = null;
		document.body.style.cursor = '';

		const rect = panel.getBoundingClientRect();
		saveStorage({ pos: { x: rect.left, y: rect.top } });

		document.removeEventListener('mousemove', onDrag);
		document.removeEventListener('mouseup', onDragEnd);
		document.removeEventListener('touchmove', onDrag);
		document.removeEventListener('touchend', onDragEnd);
	}

	header.addEventListener('mousedown', onDragStart);
	header.addEventListener('touchstart', onDragStart, { passive: false });

	// Prevent wheel events on any part of the panel from scrolling the page.
	panel.addEventListener('wheel', (e) => e.stopPropagation(), { passive: true });

	// ─── Auto-scroll ──────────────────────────────────────────────────────────

	const scrollBtn = document.createElement('button');
	scrollBtn.className = 'cam-btn cam-scroll-btn';
	scrollBtn.textContent = '↓ jump to latest';
	scrollBtn.hidden = true;
	camBody.appendChild(scrollBtn);

	camBody.addEventListener(
		'scroll',
		() => {
			const atBottom = camBody.scrollHeight - camBody.scrollTop - camBody.clientHeight < 10;
			autoScroll = atBottom;
			scrollBtn.hidden = atBottom;
		},
		{ passive: true }
	);

	scrollBtn.addEventListener('click', () => {
		autoScroll = true;
		scrollBtn.hidden = true;
		camBody.scrollTop = camBody.scrollHeight;
	});

	// Re-clamp position and size on resize so the panel stays fully on-screen.
	// applySize uses Math.min, so it also restores the saved size when the viewport grows back.
	window.addEventListener(
		'resize',
		() => {
			const { pos, size } = loadStorage();
			if (pos) applyPosition(pos);
			if (size) applySize(size);
		},
		{ passive: true }
	);

	// Persist size changes from the native resize handle (debounced)
	let resizeSaveTimer = null;
	if (typeof ResizeObserver !== 'undefined') {
		new ResizeObserver((entries) => {
			if (dragOffset) return; // ignore layout shifts during drag
			if (panel.dataset.camState === 'collapsed') return; // ignore CSS-driven shrink on collapse
			// Only persist when an explicit height exists — i.e. the user dragged
			// the resize handle (which sets an inline style.height) vs. the panel
			// naturally growing due to new events being added.
			if (!panel.style.height) return;
			const entry = entries[0];
			const bbs = entry.borderBoxSize?.[0];
			const w = bbs ? Math.round(bbs.inlineSize) : Math.round(entry.contentRect.width);
			const h = bbs ? Math.round(bbs.blockSize) : Math.round(entry.contentRect.height);
			clearTimeout(resizeSaveTimer);
			resizeSaveTimer = setTimeout(() => saveStorage({ size: { w, h } }), 300);
		}).observe(panel);
	}

	// ─── JSON Highlight ───────────────────────────────────────────────────────

	function highlightJSON(json) {
		// Escape HTML entities first so injected spans aren't affected by values
		const escaped = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		return escaped.replace(
			/("(?:\\u[0-9a-fA-F]{4}|\\[^u]|[^\\"])*"(?:\s*:)?|\b(?:true|false)\b|\bnull\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
			(match) => {
				let cls;
				if (match[0] === '"') {
					cls = match[match.length - 1] === ':' ? 'cam-json-key' : 'cam-json-string';
				} else if (match === 'true' || match === 'false') {
					cls = 'cam-json-boolean';
				} else if (match === 'null') {
					cls = 'cam-json-null';
				} else {
					cls = 'cam-json-number';
				}
				return `<span class="${cls}">${match}</span>`;
			}
		);
	}

	// ─── Render ───────────────────────────────────────────────────────────────

	function addEvent(item) {
		const { event, ...data } = item;
		count++;

		const now = new Date();
		const time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });

		const li = document.createElement('li');
		li.className = 'cam-event';
		li.dataset.event = event;

		const details = document.createElement('details');
		const summary = document.createElement('summary');

		const numSpan = document.createElement('span');
		numSpan.className = 'cam-num';
		numSpan.textContent = count;

		const nameSpan = document.createElement('span');
		nameSpan.textContent = event;

		const timeSpan = document.createElement('span');
		timeSpan.className = 'cam-time';
		timeSpan.textContent = time;

		const copyBtn = document.createElement('button');
		copyBtn.className = 'cam-btn cam-copy-btn';
		copyBtn.title = 'Copy JSON';
		copyBtn.textContent = 'copy';
		copyBtn.addEventListener('click', (e) => {
			e.stopPropagation(); // prevent details toggle
			navigator.clipboard.writeText(JSON.stringify(data, null, 2)).then(() => {
				copyBtn.textContent = '✓';
				copyBtn.style.color = '#4ade80';
				setTimeout(() => {
					copyBtn.textContent = 'copy';
					copyBtn.style.color = '';
				}, 1500);
			});
		});

		summary.appendChild(numSpan);
		summary.appendChild(nameSpan);
		summary.appendChild(timeSpan);
		summary.appendChild(copyBtn);

		const pre = document.createElement('pre');
		pre.innerHTML = highlightJSON(JSON.stringify(data, null, 2));

		details.appendChild(summary);
		details.appendChild(pre);
		li.appendChild(details);
		list.appendChild(li);

		// Cap the list at MAX_EVENTS, trimming the oldest entry
		if (list.children.length > MAX_EVENTS) list.removeChild(list.firstElementChild);

		applyFilter();
		if (autoScroll) camBody.scrollTop = camBody.scrollHeight;
	}

	function applyFilter() {
		const q = filterInput.value.trim().toLowerCase();
		let visible = 0;
		list.querySelectorAll('.cam-event').forEach((li) => {
			const hidden = Boolean(q && !li.dataset.event.toLowerCase().includes(q));
			li.hidden = hidden;
			if (!hidden) visible++;
		});
		const label = q ? `${visible} / ${count}` : count;
		countEl.textContent = label;
		pillCount.textContent = label;

		// Empty state: distinguish "no events yet" from "filter hides everything"
		const isEmpty = visible === 0;
		emptyMsg.textContent = isEmpty && q && count > 0 ? `No events match "${q}"` : 'No events yet.';
		emptyMsg.hidden = !isEmpty;
		list.hidden = isEmpty;
	}

	// ─── Controls ─────────────────────────────────────────────────────────────

	filterInput.addEventListener('input', () => {
		applyFilter();
		saveStorage({ filter: filterInput.value });
	});

	resetPosBtn.addEventListener('click', resetPosition);
	resetSizeBtn.addEventListener('click', resetSize);

	clearBtn.addEventListener('click', () => {
		count = 0;
		list.innerHTML = '';
		applyFilter();
	});

	collapseBtn.addEventListener('click', () => {
		const { state } = loadStorage();
		setState(state === 'collapsed' ? 'open' : 'collapsed');
	});

	closeBtn.addEventListener('click', () => setState('hidden'));
	pill.addEventListener('click', () => setState('open'));

	// ─── Init ─────────────────────────────────────────────────────────────────

	const { state, pos, filter } = loadStorage();
	applyState(state);
	if (filter !== undefined) {
		filterInput.value = filter;
		applyFilter();
	}
	// Position must be applied after the panel is in the DOM so layout metrics (offsetWidth/offsetHeight) are available.
	// Size is handled by applyState above; only position needs the rAF.
	requestAnimationFrame(() => {
		applyPosition(pos);
	});

	// ─── Intercept ────────────────────────────────────────────────────────────

	function makeProxy(base) {
		return new Proxy(base, {
			get(target, prop) {
				if (prop !== 'push') return target[prop];
				return function (...items) {
					items.forEach((item) => item?.event && addEvent(item));
					return Array.prototype.push.apply(target, items);
				};
			}
		});
	}

	const existing = Array.isArray(window.ElevarDataLayer) ? [...window.ElevarDataLayer] : [];
	existing.forEach((item) => item?.event && addEvent(item));

	let _layer = makeProxy(Array.isArray(window.ElevarDataLayer) ? window.ElevarDataLayer : []);
	Object.defineProperty(window, 'ElevarDataLayer', {
		get() { return _layer; },
		set(newVal) {
			// No-op if the value being assigned is already our proxy (e.g. `x = x ?? []` patterns).
			if (newVal === _layer) return;
			// Re-wrap any replacement so the Proxy — and our intercept — survive Elevar reinitializing the array.
			_layer = makeProxy(Array.isArray(newVal) ? newVal : []);
		},
		configurable: true,
		enumerable: true,
	});
})();
